import EmberRouter from '@embroider/router';
//import EmberRouter from '@ember/routing/router';
import config from 'photodiode/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('photodiode');
  this.route('circuit');
  this.route('nextsteps');
});
